export enum TrafficSourceOrderType {
  DIRECT_INSTALLS = "DIRECT_INSTALLS",
  KEYWORDS = "KEYWORDS",
  RATINGS = "RATINGS",
  REVIEWS = "REVIEWS",
}

export interface TrafficSource {
  // __typename?: string;
  id?: string;
  orderType: TrafficSourceOrderType;
  price: number;
  platform: "IOS" | "ANDROID";
  email: string;
  reservationStatus: "DEFAULT" | "RESERVE";
}
